import React, { useContext, useState, useCallback, useEffect } from "react";
import LeftBanner from "./LeftBanner";
import PreviousSessions from "./PreviousSessions";
import ProfileUpdate from "./ProfileUpdate";
import UpcomingSessions from "./UpcomingSessions";
import UsersList from "./UsersList";
import NavBar from "../NavBar.jsx";
import lock from "../../Utils/Svg/lock.svg";
import { useNavigate, useLocation } from "react-router-dom";
import Context from "../../Context/Context";
import Main from "./Choreography/components/Main";
import PaymentDetails from "./Revenue";
import Billing from "./Billing";
import MembersPage from "./UsersList/MembersPage";
import { API } from "aws-amplify";

const DashBoard = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const [click, setClick] = useState(0);
  const [userCheck, setUserCheck] = useState(0);
  const Ctx = useContext(Context);
  const {
    isAuth,
    userData,
    setVideos,
    setError,
    setLoading,
    setPlaylists,
    setErrorPlaylist,
    setLoadingPlaylist,
    setUpcomingClasses,
    setInstructorList,
    setPreviousClasses,
    setUserList,
    setLoadingUpcoming,
    setLoadingInstructors,
    setLoadingPrevious,
    setLoadingUserList,
  } = Ctx;
  const unpaidUser = {
    text: "Embrace a world of possibilities. Unlock exclusive features. Subscribe now and elevate your experience with our extraordinary offerings.",
  };

  // Set click state based on URL path
  useEffect(() => {
    if (location.pathname === "/dashboard/upcomingsession") {
      setClick(0); // 0 corresponds to UpcomingSessions
    } else if (location.pathname === "/dashboard/previoussession") {
      setClick(1); // 1 corresponds to PreviousSessions
    } else if (location.pathname === "/dashboard/choreography") {
      setClick(2); // 2 corresponds to Choreography
    } else if (location.pathname === "/dashboard/members") {
      setClick(4); // 4 corresponds to Members
    } else if (location.pathname === "/dashboard/revenue") {
      setClick(5); // 5 corresponds to Revenue
    } else if (location.pathname === "/dashboard/account") {
      setClick(3); // 3 corresponds to Account
    }
  }, [location.pathname]);

  useEffect(() => {
    if (isAuth) {
      const onLoad = async () => {
        try {
          setLoadingUpcoming(true);
          const classes = await API.get("user", "/user/upcoming-schedule");
          setUpcomingClasses(classes.data);
        } catch (e) {
          setUpcomingClasses([]);
          console.log(e);
        } finally {
          setLoadingUpcoming(false);
        }

        try {
          setLoadingPrevious(true);
          const classes = await API.get("user", "/user/previous-schedule");
          setPreviousClasses(classes.data);
        } catch (e) {
          setPreviousClasses([]);
          console.log(e);
        } finally {
          setLoadingPrevious(false);
        }

        try {
          setLoadingUserList(true);
          const list = await API.get(
            "user",
            `/admin/profile-list/${userData.cognitoId}`
          );
          setUserList(list);
        } catch (e) {
          console.log(e);
          setUserList([]);
        } finally {
          setLoadingUserList(false);
        }
      };

      API.get("user", "/any/instructor-list/Bworkz")
        .then((data) => {
          console.log("Instructor List API Response:", data);
          console.log("Response Type:", typeof data, Array.isArray(data));
          // Handle different response formats
          let instructorData = data;
          if (data && !Array.isArray(data)) {
            // Check if it's wrapped in body (AWS Lambda response)
            if (data.body) {
              try {
                instructorData = typeof data.body === 'string' ? JSON.parse(data.body) : data.body;
                console.log("Parsed from body:", instructorData);
              } catch (e) {
                console.error("Error parsing body:", e);
              }
            }
            // Check if it's wrapped in data
            if (data.data && Array.isArray(data.data)) {
              instructorData = data.data;
              console.log("Found in data property:", instructorData);
            }
            // Check if it's wrapped in instructors
            if (data.instructors && Array.isArray(data.instructors)) {
              instructorData = data.instructors;
              console.log("Found in instructors property:", instructorData);
            }
          }
          console.log("Final Instructor List to set:", instructorData);
          setInstructorList(Array.isArray(instructorData) ? instructorData : []);
        })
        .catch((e) => {
          console.error("Error fetching instructor list:", e);
          setInstructorList([]);
        });

      onLoad();
    }
  }, [isAuth]);

  const fetchVideos = useCallback(async () => {
    if (!isAuth) return;

    setLoading(true);
    setError(null);
    try {
      const response = await API.get("user", "/user/fetch-videos");
      if (response.videos && Array.isArray(response.videos)) {
        setVideos(response.videos);
      } else {
        console.error("Unexpected response format:", response);
        setError("Unexpected response format");
      }
    } catch (err) {
      console.error("Error fetching videos:", err);
      setError("Failed to fetch videos");
    } finally {
      setLoading(false);
    }
  }, [isAuth]);

  // Fetch playlists once when user is authenticated
  const fetchPlaylists = useCallback(async () => {
    if (!isAuth) return;

    setLoadingPlaylist(true);
    setErrorPlaylist(null);
    try {
      const response = await API.get("user", "/user/get-playlist");
      console.log(response);
      const uniquePlaylists = response.playlists.reduce((acc, playlist) => {
        if (!acc.some((p) => p.playlistName === playlist.playlistName)) {
          acc.push(playlist);
        }
        return acc;
      }, []);
      setPlaylists(uniquePlaylists);
    } catch (err) {
      console.error("Error fetching playlists:", err);
      setErrorPlaylist("Failed to fetch playlists");
    } finally {
      setLoadingPlaylist(false);
    }
  }, [isAuth]);

  useEffect(() => {
    if (isAuth) {
      fetchVideos();
      fetchPlaylists();
    }
  }, [isAuth, fetchVideos, fetchPlaylists]);

  const displayAfterClick = () => {
    switch (click) {
      case 0:
        return <UpcomingSessions />;

      case 1:
        return <PreviousSessions />;

      case 2:
        return <Main />;

      case 3:
        return <ProfileUpdate />;

      case 4:
        return <MembersPage />;

      case 5:
        return <PaymentDetails />;

      case 7:
        if (Ctx.userData?.userType === "member") {
          return <Billing />;
        } else {
          return <PaymentDetails />;
        }

      default:
        return <div></div>;
    }
  };

  return (
    <>
      <NavBar />
      <div className="flex flex-col  items-center max-w-screen mt-7 sm:mt-0">
        <div className="w-full rounded-3xl flex max1050:w-screen max1050:ml-0 max536:rounded-none items-top ml-0 h-full relative !scrollbar-hide">
          <LeftBanner
            displayAfterClick={(data) => {
              setClick(data);
            }}
          />
          <div
            className={`flex flex-col w-[100%] justify-start min-h-[93vh] max-h-[93vh] overflow-y-auto scrollbar-hide transition-colors duration-200 pb-20 min800:pb-0 ${
              Ctx.isDarkMode ? 'bg-black' : 'bg-white'
            }`}
          >
            {Ctx.userData.status === "InActive" &&
            Ctx.userData.userType === "member" ? (
              <div className="relative ">
                <div className="absolute z-10 top-[30%] right-[15%] max1050:w-[92%] flex justify-between rounded-[0.51rem]">
                  <div className="w-[100%]">
                    <div className="locked-screen relative flex items-center justify-center text-center mt-[3.5rem]">
                      <div className="unlock-button">
                        <h2 className="w-[fit-content] text-[1.5rem] max500:text-[1.2rem] ml-[5rem]">
                          {unpaidUser.text}
                        </h2>
                        <div
                          className="Subscribe-button ml-[8rem] bg-[#FDCF08] w-[6rem] h-[3rem] m-[2rem] rounded-[1.5rem] text-white cursor-pointer"
                          onClick={() => {
                            // Redirect the user to the subscription page
                            Navigate("/subscription");
                          }}
                        >
                          <img
                            src={lock} // Provide the source for the lock image
                            alt=""
                            className="top-8 w-[2.8rem] translate-x-[-2%] absolute fa-4x mb-4"
                            onClick={() => {
                              // Redirect the user to the subscription page
                              Navigate("/subscription");
                            }}
                          />

                          <span className="Latch">
                            <span className="Lock"></span>
                          </span>
                          <span className="UnlockText  ">UNLOCK</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="opacity-[20%] pointer-events-none">{displayAfterClick()}</div>
              </div>
            ) : (
              displayAfterClick()
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DashBoard;
